import { GenericEntityBase } from "./GenericEntityBase";

// Alias pour les composants parents (rel TKey indetermine)
export abstract class EntityBase extends GenericEntityBase<any> {
}
